import { CircleX } from "lucide-react";
import { IconButton } from "@/components/ui/icon-button";

export function LaunchErrorBanner({
  message,
  onDismiss,
}: {
  message: string;
  onDismiss: () => void;
}) {
  return (
    <div
      className="fixed inset-x-0 top-4 z-50 flex justify-center px-4 pointer-events-none"
      role="alert"
      aria-live="assertive"
    >
      <div className="pointer-events-auto w-full max-w-xl rounded-m border border-state-negative bg-neutral-background-200 p-5 shadow-l">
        <div className="flex items-center justify-between gap-4">
          <div className="text-h3 font-medium">Не удалось открыть встречу по ссылке</div>
          <IconButton
            variant="ghost"
            size="xs"
            onClick={onDismiss}
            aria-label="Закрыть"
            className="h-auto p-0"
          >
            <CircleX
              className="h-5 w-5 hover:opacity-80 transition-opacity"
              color="var(--color-state-negative)"
            />
          </IconButton>
        </div>
        <div className="mt-2 text-body1 text-neutral-text-800">{message}</div>
      </div>
    </div>
  );
}
